module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "pagehead"
  }, [_c('a', {
    attrs: {
      "href": "#/contents#plate"
    }
  }, [_c('b', [_vm._v("Plates")])])]), _vm._v(" "), _c('p', {
    staticClass: "image0"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/image1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/plates#pl-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1    Sir William Dobbie")]), _c('a', {
    attrs: {
      "id": "pl_1"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/plates#pl-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2    Admiral Cunningham")]), _c('a', {
    attrs: {
      "id": "pl_2"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/plates#pl-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3    Sir Winston Churchill")]), _c('a', {
    attrs: {
      "id": "pl_3"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/plates#pl-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4    Lord Gort")]), _c('a', {
    attrs: {
      "id": "pl_4"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/plates#pl-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5    Hitler & Mussolini")]), _c('a', {
    attrs: {
      "id": "pl_5"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/plates#pl-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6    Albert Kesselring")]), _c('a', {
    attrs: {
      "id": "pl_6"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/plates#pl-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7    Erwin Rommel")]), _c('a', {
    attrs: {
      "id": "pl_7"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/plates#pl-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8    Dock Creek")]), _c('a', {
    attrs: {
      "id": "pl_8"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/plates#pl-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9    Grand Harbour at Valletta")]), _c('a', {
    attrs: {
      "id": "pl_9"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/plates#pl-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10  Malta Spitfire and ground crew")]), _c('a', {
    attrs: {
      "id": "pl_10"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/plates#pl-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11  Junkers")]), _c('a', {
    attrs: {
      "id": "pl_11"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/plates#pl-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12  Junkers")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/plates#pl-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13  Heinkel")]), _c('a', {
    attrs: {
      "id": "pl_12"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/plates#pl-13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14  Messerschmitt")]), _c('a', {
    attrs: {
      "id": "pl_13"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/plates#pl-14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15  AA battery, Valletta’s Grand Harbour")]), _c('a', {
    attrs: {
      "id": "pl_14"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/plates#pl-15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16  Valetta’s Grand Harbour under aerial bombardment")]), _c('a', {
    attrs: {
      "id": "pl_15"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/plates#pl-16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17  ‘The Morning After’, Kingsway, Valetta")]), _c('a', {
    attrs: {
      "id": "pl_16"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/plates#pl-17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18  Christmas lunch")]), _c('a', {
    attrs: {
      "id": "pl_17"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/plates#pl-18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19  Bomb damage, Valletta")]), _c('a', {
    attrs: {
      "id": "pl_18"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/plates#pl-19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20  A Victory kitchen queue")]), _c('a', {
    attrs: {
      "id": "pl_19"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/plates#pl-20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21  Kingsway after a raid")]), _c('a', {
    attrs: {
      "id": "pl_20"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/plates#pl-21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22  HMS "), _c('i', [_vm._v("Speedy")])]), _c('a', {
    attrs: {
      "id": "pl_21"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/plates#pl-22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23  The "), _c('i', [_vm._v("Ohio")])]), _c('a', {
    attrs: {
      "id": "pl_22"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/plates#pl-23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24  HMS "), _c('i', [_vm._v("Eagle")])]), _c('a', {
    attrs: {
      "id": "pl_23"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/plates#pl-24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25  The "), _c('i', [_vm._v("Brisbane Star")])]), _c('a', {
    attrs: {
      "id": "pl_24"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/plates#pl-25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26  The "), _c('i', [_vm._v("Port Chalmers")])]), _c('a', {
    attrs: {
      "id": "pl_25"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/plates#pl-26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27  The "), _c('i', [_vm._v("Melbourne Star")])]), _c('a', {
    attrs: {
      "id": "pl_26"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/plates#pl-27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28  Arrival of the "), _c('i', [_vm._v("Ohio")])]), _c('a', {
    attrs: {
      "id": "pl_27"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/plates#pl-28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29  The "), _c('i', [_vm._v("Rochester Castle")])]), _c('a', {
    attrs: {
      "id": "pl_28"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/plates#pl-29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30  Waiting for the "), _c('i', [_vm._v("Ohio")])]), _c('a', {
    attrs: {
      "id": "pl_29"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/plates#pl-30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31  "), _c('i', [_vm._v("Pedestal")]), _vm._v(" survivors")]), _c('a', {
    attrs: {
      "id": "pl_30"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/plates#pl-31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32  Torpedo Fork 1")]), _c('a', {
    attrs: {
      "id": "pl_31"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/plates#pl-31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33  Torpedo Fork 2")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/plates#pl-32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34  The George Cross")]), _c('a', {
    attrs: {
      "id": "pl_32"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "plate"
  }, [_c('a', {
    attrs: {
      "href": "#/contents#map"
    }
  }, [_c('b', [_vm._v("Maps")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "href": "#/maps#map-1"
    }
  }, [_vm._v("1    Malta and Gozo")]), _c('a', {
    attrs: {
      "id": "map_1"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "href": "#/maps#map-2"
    }
  }, [_vm._v("2    Valletta and the Three Cities")]), _c('a', {
    attrs: {
      "id": "map_2"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "href": "#/maps#map-3"
    }
  }, [_vm._v("3    Malta Beseiged")]), _c('a', {
    attrs: {
      "id": "map_3"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "href": "#/maps#map-4"
    }
  }, [_vm._v("4    Operation Pedestal")]), _c('a', {
    attrs: {
      "id": "map_4"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "href": "#/maps#map-5"
    }
  }, [_vm._v("5    Malta’s Role in Disrupting Axis Shipping")]), _c('a', {
    attrs: {
      "id": "map_5"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bfa2ab78","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/listofplates.vue
// module id = 72
// module chunks = 0